export default {
  Width: 53,
};
